<template>
  <div>
    <div class="row xlarge-collapse align-center">
      <header class="columns small-12 medium-8 text-center">
        <h1>Testimonials &amp; Reviews</h1>
        <p class="text-big">
          {{ description }}
        </p>
        <br />
      </header>
    </div>
    <section class="row section xlarge-collapse align-center">
      <div class="columns small-12 medium-8">
        <div id="reviews-widget" style="width: 100%"></div>
      </div>

      <div class="columns small-12 medium-4 text-center">
        <div
          class="fb-page"
          data-href="https://www.facebook.com/teachstarter"
          data-tabs="timeline"
          data-width=""
          data-height=""
          data-small-header="false"
          data-adapt-container-width="true"
          data-hide-cover="false"
          data-show-facepile="true"
        >
          <div cite="https://www.facebook.com/teachstarter" class="fb-xfbml-parse-ignore">
            <a href="https://www.facebook.com/teachstarter">Teach Starter</a>
          </div>
        </div>
        <div id="fb-root"></div>
      </div>
    </section>
  </div>
</template>

<script>
/* Testimonials
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components:
 * @methods:
 */

export default {
  name: 'Testimonials',
  data() {
    return {
      title: 'Testimonials & Reviews',
      description: 'Our members are passionate about our resources and service. Find out why...',
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
      link: this.$hrefLangsPage(this.$route),
      __dangerouslyDisableSanitizersByTagID: {
        reviewsioInit: ['innerHTML'],
      },
      script: [
        {
          hid: 'reviewsio',
          src: 'https://widget.reviews.io/rich-snippet-reviews-widgets/dist.js',
          defer: true,
        },
        {
          hid: 'reviewsioInit',
          innerHTML:
            'window.setTimeout(function() {richSnippetReviewsWidgets("reviews-widget", { store: "teachstarter-com", widgetName: "vertical", primaryClr: "#78bc3a", layout: "fullWidth", height: 1000, numReviews: 200 });}, 1000)',
        },
        {
          hid: 'facebook',
          src: 'https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v10.0',
          defer: true,
          nonce: 'VfEKR36w',
        },
      ],
    };
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
};
</script>

<style lang="scss">
#reviews-widget {
  background-color: $grey-0;
  min-height: 300px;
}

#reviews-widget_frame {
  height: 1000px !important;
}
</style>
